import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

function BackgroundOption({
  isBgRemoved,
  cropped_url,
  bgRemovedUrl,
  showedBgRemovedUrl,
  getTexture,
}) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
  }, []);

  return (
    <>
      <div
        className={`mainFlex manCustomBgSec ${
          isBgRemoved !== null && isBgRemoved && "activeLogoType"
        } mb-2`}
        onClick={() => getTexture(bgRemovedUrl, null, true)}
      >
        <div className="img_remove_bg_Image">
          {loading && (
            <div className="loader gap-2" style={{ fontSize: 13 }}>
              <Spinner style={{ height: 20, width: 20, borderWidth: 1 }} />{" "}
              Loading...
            </div>
          )}
          <img src={showedBgRemovedUrl} alt="" />
        </div>

        <div className="img_remove_bg_text">
          <span style={{ fontSize: 16, fontWeight: "700 !important" }}>
            Remove All Background
          </span>
          <span style={{ fontSize: 14, fontWeight: 400, textWrap: "wrap" }}>
            Remove all parts of logo that match four corners of the image.
          </span>
        </div>
      </div>
      <div
        className={`mainFlex manCustomBgSec ${
          isBgRemoved !== null && !isBgRemoved && "activeLogoType"
        }`}
        onClick={() => getTexture(cropped_url, null, false)}
      >
        <div className="img_remove_bg_Image">
          {loading && (
            <div className="loader gap-2" style={{ fontSize: 13 }}>
              <Spinner style={{ height: 20, width: 20, borderWidth: 1 }} />{" "}
              Loading...
            </div>
          )}
          <img src={cropped_url} alt="" onLoad={() => setLoading(false)} />
        </div>

        <div className="img_remove_bg_text">
          <span style={{ fontSize: 16, fontWeight: "700 !important" }}>
            Original
          </span>

          <span style={{ fontSize: 14, fontWeight: 400, textWrap: "wrap" }}>
            Covert as uploaded e.g transparent PNG, JPEG.
          </span>
        </div>
      </div>
    </>
  );
}

export default BackgroundOption;
